import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Badge,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";

//import images
import waterDepositsSvg from "../../../assets/images/svg/waterDeposits.svg";
import TableContainer from "Components/Common/TableContainer";
import { numberWithCommas } from "../../../helpers/globalHelper";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useCommonDataFindAllQuery, useGroundwaterCreateMutation, useGroundwaterDeleteMutation, useGroundwaterFindAllQuery, useGroundwaterUpdateMutation } from "store";
import DeleteModal from "Components/Common/DeleteModal";
import Dropzone from "react-dropzone";
import Switch from "react-switch";
import ShapeUpload from "Components/fileUpload/ShapeUpload";
import Flatpickr from "react-flatpickr";


const Detail = ({ searchField }: any) => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [modal_backdrop, setmodal_backdrop] = useState(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isLoading, setLoading] = useState(true);

  const [groundwaterOne, setGroundwaterOne] = useState<any>();
  const [groundwaterList, setGroundwaterList] = useState<any>();
  const [groundwaterCount, setGroundwaterCount] = useState<any>();

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  const { data, error, isFetching } = useGroundwaterFindAllQuery(customQuery);
  const [mineralBoolean, setMineralBoolean] = useState<boolean>(false);


  const [groundwaterUpdate, groundwaterUpdateResult] = useGroundwaterUpdateMutation();
  const [groundwaterCreate, groundwaterCreateResult] = useGroundwaterCreateMutation();
  const [groundwaterDelete, groundwaterDeleteResult] = useGroundwaterDeleteMutation();

  const {
    data: groundwater_type,
    error: groundwater_typeError,
    isFetching: isGroundwater_typeFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_groundwater_type`);

  const {
    data: cost_source,
    error: cost_sourceError,
    isFetching: isCost_sourceFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_invesetment_source`);



  useEffect(() => {
    setGroundwaterList(data?.data);
    setLoading(false);
    setGroundwaterCount(groundwaterList?.length);

    const tempMineral = groundwaterOne !== null ? groundwaterOne?.is_mineral : false;
    setMineralBoolean(tempMineral)


    setCustomPagination(data?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1
      }&pageSize=${customPageSize !== undefined ? customPageSize : 25}&${searchField !== undefined ? searchField : ''}`;
    setCustomQuery(tempQuery);
  }, [data, groundwaterList, customPageSize, customPageLength, customPagination, searchField]);

  const toggle = useCallback(() => {
    if (modal_backdrop) {
      setmodal_backdrop(false);
      setGroundwaterOne(null);
    } else {
      setmodal_backdrop(true);
    }
  }, [modal_backdrop]);

  const handleJobClick = useCallback((arg: any) => {
    const groundwaterData = arg;
    setGroundwaterOne({
      id: groundwaterData.id,
      code: groundwaterData.code,
      name: groundwaterData.name,
      cmn_groundwater_type: groundwaterData.cmn_groundwater_type,
      decision_date: groundwaterData.decision_date,
      decision_no: groundwaterData.decision_no,
      budget_cost: groundwaterData.budget_cost,
      cmn_invesetment_source: groundwaterData.cmn_invesetment_source,
      research_date: groundwaterData.research_date,
      drilled_organization_description: groundwaterData.drilled_organization_description,
      location: groundwaterData.location,
    });
    setMineralBoolean(groundwaterData?.is_mineral)


    setIsEdit(true);
    toggle();
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (groundwaterData) => {
    setGroundwaterOne(groundwaterData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (groundwaterOne) {
      groundwaterDelete(groundwaterOne.id);
      setDeleteModal(false);
    }
  };

  const handleJobClicks = () => {
    setIsEdit(false);
    setGroundwaterOne(null);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: "№",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Код",
        accessorKey: "code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Нэр",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Төрөл",
        accessorKey: "cmn_groundwater_type",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Рашаан эсэх",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "is_mineral",
      },
      {
        header: "Байршил",
        accessorKey: "location",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Үйлдэл",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link to={`/under/ground/water/deposits/show/${cellProps.row.original.id}`} className="btn btn-sm btn-soft-primary">
                  <i className="mdi mdi-eye-outline" id="viewtooltip"></i>
                </Link>
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  View
                </UncontrolledTooltip>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const groundwaterData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(groundwaterData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Устгах
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-warning"
                  onClick={(event: any) => {
                    const groundwaterData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(groundwaterData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    []
  );

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: groundwaterOne?.id,
      code: groundwaterOne?.code,
      name: groundwaterOne?.name,
      cmn_groundwater_type: groundwaterOne?.cmn_groundwater_type,
      is_mineral: groundwaterOne?.is_mineral,
      decision_date: groundwaterOne?.decision_date,
      decision_no: groundwaterOne?.decision_no,
      budget_cost: groundwaterOne?.budget_cost,
      cmn_invesetment_source: groundwaterOne?.cmn_invesetment_source,
      research_date: groundwaterOne?.research_date,
      drilled_organization_description: groundwaterOne?.drilled_organization_description,
      location: groundwaterOne?.location,
    },
    validationSchema: Yup.object({
      code: Yup.string().required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (isEdit) {
        const formData = new FormData();

        formData.append('id', groundwaterOne ? groundwaterOne.id.toString() : '0');
        formData.append('code', values?.code);
        formData.append('name', values?.name);
        formData.append('cmn_groundwater_type', values?.cmn_groundwater_type);
        formData.append('is_mineral', String(mineralBoolean ?? false));
        formData.append('decision_date', values?.decision_date);
        formData.append('decision_no', values?.decision_no);
        formData.append('budget_cost', values?.budget_cost);
        formData.append('cmn_invesetment_source', values?.cmn_invesetment_source);
        formData.append('research_date', values?.research_date);
        formData.append('drilled_organization_description', values?.drilled_organization_description);
        formData.append('location', values?.location);
        groundwaterUpdate(formData)
      } else {
        const formData = new FormData();

        formData.append('code', values?.code);
        formData.append('name', values?.name);
        formData.append('cmn_groundwater_type', values?.cmn_groundwater_type);
        formData.append('is_mineral', String(mineralBoolean ?? false));
        formData.append('decision_date', values?.decision_date);
        formData.append('decision_no', values?.decision_no);
        formData.append('budget_cost', values?.budget_cost);
        formData.append('cmn_invesetment_source', values?.cmn_invesetment_source);
        formData.append('research_date', values?.research_date);
        formData.append('drilled_organization_description', values?.drilled_organization_description);
        formData.append('location', values?.location);

        if (selectedFiles && selectedFiles.length > 0) {
          selectedFiles.forEach((file: File, index: number) => {
            formData.append(`shapes`, file);
          });
        }

        groundwaterCreate(formData)
      }
      validation.resetForm();
      setmodal_backdrop(false)
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (
    <React.Fragment>
      <DeleteModal
        deleteName={groundwaterOne?.name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Col xl={9}>
        <Card>
          <CardBody className="border-bottom">
            <div className="d-flex align-items-center">
              <img src={waterDepositsSvg} alt="" height="50" />
              <div className="flex-grow-1 ms-3">
                <h5 className="fw-semibold">Мэдээлэл</h5>
                <ul className="list-unstyled hstack gap-2 mb-0">
                  <li>
                    <i className="mdi mdi-table-row-height"></i>{" "}
                    <span className="text-muted fw-semibold">
                      Нийт: {numberWithCommas(groundwaterCount)}{" "}
                    </span>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                onClick={() => {
                  toggle();
                  setGroundwaterOne(null);
                }}
                className="btn btn-success  btn-label"
              >
                <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр
                нэмэх
              </button>
            </div>
          </CardBody>

          <CardBody>
            <TableContainer
              setCustomPageSize={setCustomPageSize}
              setCustomPageLength={setCustomPageLength}
              customPagination={customPagination}
              columns={columns}
              data={groundwaterList || ""}
              isCustomPageSize={true}
              isPagination={true}
              colWidth={2}
              SearchPlaceholder="Хэрэглэгч хайх . . ."
              tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            />
          </CardBody>
        </Card>
      </Col>

      <Modal
        size="xl"
        isOpen={modal_backdrop}
        toggle={() => {
          toggle();
        }}
        backdrop={"static"}
        id="staticBackdrop"
        centered
      >
        <ModalHeader
          toggle={() => {
            toggle();
          }}
        >
          <div className="h5 modal-title" id="staticBackdropLabel">
            {!!isEdit ? "Услалтын систем мэдээлэл засах" : "Услалтын систем мэдээлэл нэмэх"}
          </div>
        </ModalHeader>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <Alert color="warning" className="mb-3">
              <strong className="text-danger">(*)</strong> тэмдэг бүхий талбарыг {""}
              <Link to="#" className="alert-link">
                заавал бөглөх
              </Link>  шаардлагатайг анхаарна уу !!!
            </Alert>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label className="text-danger"> Бүртгэлийн дугаар *</Label>
                  <Input
                    name="code"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.code || ""}
                    invalid={
                      validation.touched.code &&
                        validation.errors.code
                        ? true
                        : false
                    }
                  />
                  {validation.touched.code &&
                    validation.errors.code ? (
                    <FormFeedback type="invalid">
                      {validation.errors.code}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger"> Ордын нэр *</Label>
                  <Input
                    name="name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label className="text-danger"> Ордын төрөл *</Label>
                  <Input
                    name="cmn_groundwater_type"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.cmn_groundwater_type || ""}
                    invalid={
                      validation.touched.cmn_groundwater_type &&
                        validation.errors.cmn_groundwater_type
                        ? true
                        : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {groundwater_type?.data?.map((item, index) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.cmn_groundwater_type &&
                    validation.errors.cmn_groundwater_type ? (
                    <FormFeedback type="invalid">
                      {validation.errors.cmn_groundwater_type}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label className="text-danger">Рашаан эсэх *</Label> <br />
                  <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    className="me-1 mb-sm-8 mb-2 ms-3"
                    onColor="#626ed4"
                    onChange={() => {
                      setMineralBoolean(!mineralBoolean);
                    }}
                    checked={mineralBoolean}
                  />
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Батлагдсан огноо  *</Label>
                  <Flatpickr
                    className="form-control d-block"
                    placeholder="Огноо"
                    name="decision_date"
                    value={validation.values.decision_date}
                    onChange={(selectDate: Date[]) => {
                      if (selectDate[0]) {
                        const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                          .toISOString()
                          .split('T')[0];
                        validation.setFieldValue('decision_date', localDate);
                      }
                    }}
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                      enableTime: false,
                    }}
                  />

                  {validation.touched.decision_date && validation.errors.decision_date ? (
                    <FormFeedback status="invalid">
                      {validation.errors.decision_date}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Баталгаажсан шийдвэрийн огноо  *</Label>
                  <Flatpickr
                    className="form-control d-block"
                    placeholder="Огноо"
                    name="decision_no"
                    value={validation.values.decision_no}
                    onChange={(selectDate: Date[]) => {
                      if (selectDate[0]) {
                        const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                          .toISOString()
                          .split('T')[0];
                        validation.setFieldValue('decision_no', localDate);
                      }
                    }}
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                      enableTime: false,
                    }}
                  />
                  {validation.touched.decision_no && validation.errors.decision_no ? (
                    <FormFeedback status="invalid">
                      {validation.errors.decision_no}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <Label className="text-danger">Төсөв өртөг  *</Label>
                  <Input
                    name="budget_cost"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.budget_cost || ""}
                    invalid={
                      validation.touched.budget_cost && validation.errors.budget_cost
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.budget_cost && validation.errors.budget_cost ? (
                    <FormFeedback status="invalid">
                      {validation.errors.budget_cost}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">	Хөрөнгө оруулалтын төрөл *</Label>
                  <Input
                    name="cmn_invesetment_source"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.cmn_invesetment_source || ""}
                    invalid={
                      validation.touched.cmn_invesetment_source &&
                        validation.errors.cmn_invesetment_source
                        ? true
                        : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {cost_source?.data?.map((item, index) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.cmn_invesetment_source &&
                    validation.errors.cmn_invesetment_source ? (
                    <FormFeedback type="invalid">
                      {validation.errors.cmn_invesetment_source}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Огноо *</Label>
                  <Flatpickr
                    className="form-control d-block"
                    placeholder="Огноо"
                    name="research_date"
                    value={validation.values.research_date}
                    onChange={(selectDate: Date[]) => {
                      if (selectDate[0]) {
                        const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                          .toISOString()
                          .split('T')[0];
                        validation.setFieldValue('research_date', localDate);
                      }
                    }}
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                      enableTime: false,
                    }}
                  />
                  {validation.touched.research_date && validation.errors.research_date ? (
                    <FormFeedback status="invalid">
                      {validation.errors.research_date}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Өрөмдсөн байгууллагын нэр *</Label>
                  <Input
                    name="drilled_organization_description"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.drilled_organization_description || ""}
                    invalid={
                      validation.touched.drilled_organization_description && validation.errors.drilled_organization_description
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.drilled_organization_description && validation.errors.drilled_organization_description ? (
                    <FormFeedback status="invalid">
                      {validation.errors.drilled_organization_description}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Байршил  *</Label>
                  <Input
                    name="location"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.location || ""}
                    invalid={
                      validation.touched.location && validation.errors.location
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.location && validation.errors.location ? (
                    <FormFeedback status="invalid">
                      {validation.errors.location}
                    </FormFeedback>
                  ) : null}
                </div>


              </Col>
            </Row>
            {!!isEdit ? '' :
              <Row>

                <ShapeUpload selectFiles={setSelectedFiles} onReset={resetFiles} />
              </Row>
            }

          </ModalBody>

          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={() => {
              setmodal_backdrop(false);
            }}>Хаах</button>
            <button type="submit" className="btn btn-primary"> Хадгалах </button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default Detail;
